import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient) {}

  buscaCep(cep: string): Observable<any>{
    return this.http.get(`https://viacep.com.br/ws/${cep}/json/unicode/`);
  }

  uf(): Observable<any>{
    return this.http.get('assets/data/ufs.json');
  }
  tipoHorario(): Observable<any>{
    return this.http.get('assets/data/tipo_horario.json');
  }

  tipoTel(): Observable<any>{
    return this.http.get('assets/data/tipo_tel.json');
  }
}
